import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48">
    <rect width="48" height="48" fill="#CDE4DD" rx="10"></rect>
    <path
      fill="#057953"
      d="M26.98 12.73c-6.22-1.666-12.622 2.03-14.289 8.25s2.03 12.622 8.25 14.289 12.622-2.03 14.289-8.25-2.018-12.619-8.25-14.288m1.1 12.796-5.469 3.644-.646.43c-.896.594-1.405.24-1.125-.808l1.196-4.463-1.916-.513c-.867-.232-.962-.825-.212-1.325l5.47-3.644.646-.43c.896-.594 1.405-.24 1.124.808l-1.196 4.463 1.916.513c.868.233.963.826.213 1.325"></path>
  </svg>
);

export default SvgIcon;
